import { render, staticRenderFns } from "./submenu_rudc.vue?vue&type=template&id=2bbd8983&"
import script from "./submenu_rudc.vue?vue&type=script&lang=ts&"
export * from "./submenu_rudc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports